import { render, staticRenderFns } from "./mgmtContent.vue?vue&type=template&id=b60e0ba6&scoped=true&"
import script from "./mgmtContent.vue?vue&type=script&lang=js&"
export * from "./mgmtContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60e0ba6",
  null
  
)

export default component.exports